/**
 * Escapes a value for use in HTML text and quoted attribute values.
 * @param {*} value
 * @returns {string}
 */
export default function escapeHtml(value) {
	return String(value ?? '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
}
